export default __webpack_public_path__ + "media/images/services-08-770x485-8de081b1ff8f2f3c5df81846335ebe46.jpg";